import { loadStripe } from '@stripe/stripe-js';

// 获取Stripe publishable key
const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || 'pk_test_your_publishable_key_here';

// 初始化Stripe
export const stripePromise = loadStripe(stripePublishableKey);

// Stripe配置
export const stripeConfig = {
  publishableKey: stripePublishableKey,
  currency: 'usd',
  locale: 'en'
};

export default stripePromise;
